import axios from ".";

import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();

export const getDashboardWidget = () => {
  return axios({
    method: "GET",
    url: "/widgets-dashboard",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getWidgetLibrary = () => {
  return axios({
    method: "GET",
    url: "/widgets-dashboard/library",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateDashboardLayout = (data: any) => {
  return axios({
    method: "PUT",
    url: "/widgets-dashboard/layout",
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addNewWidget = (data: any) => {
  return axios({
    method: "POST",
    url: "/widgets-dashboard/widget",
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateDashboardExpend = (data: any) => {
  return axios({
    method: "PUT",
    url: "/widgets-dashboard/state",
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteWidgetItem = async (id: string) => {
  try {
    const response = await axios({
      method: "DELETE",
      url: `/widgets-dashboard/widget/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (e) {
    return null;
  }
};
